import React, { useState } from "react";
import { X } from "lucide-react";
import ImageUploader from "@/components/ImageUploader";

const CoachEraModal = ({ era, token, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    coach_name: era?.coach_name || '',
    years: era?.years || '',
    description: era?.description || '',
    thumbnail: era?.thumbnail || '',
    championships: era?.championships || 0
  });
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Edit Coach Era</h2>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label className="form-label">Coach Name</label>
              <input
                type="text"
                className="form-input"
                value={formData.coach_name}
                onChange={(e) => setFormData({ ...formData, coach_name: e.target.value })}
                placeholder="e.g., John Calipari"
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">Years</label>
              <input
                type="text"
                className="form-input"
                value={formData.years}
                onChange={(e) => setFormData({ ...formData, years: e.target.value })}
                placeholder="e.g., 2009-2024"
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">Championships</label>
              <input
                type="number"
                className="form-input"
                value={formData.championships}
                onChange={(e) => setFormData({ ...formData, championships: parseInt(e.target.value) || 0 })}
                min="0"
              />
            </div>
            
            <ImageUploader
              value={formData.thumbnail}
              onChange={(url) => setFormData({ ...formData, thumbnail: url })}
              token={token}
              label="Coach Photo"
            />
            
            <div className="form-group">
              <label className="form-label">Description</label>
              <textarea
                className="form-textarea"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                placeholder="Era description..."
              />
            </div>
          </div>
          
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Update Coach Era
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CoachEraModal;
